import React, { useState } from 'react';
import LayoutHeader from './components/LayoutHeader';
import HomePage from './components/Pages/HomePage';
import ServicesPage from './components/Pages/ServicesPage';
import AboutPage from './components/Pages/AboutPage';
import ContactPage from './components/Pages/ContactPage';
import PlatformsPage from './components/Pages/PlatformsPage';
import Footer from './components/Footer';
import TeamSection from './components/TeamSection';
import CookieConsent from './components/CookieConsent';
import TermsPage from './components/Pages/TermsPage';
import PrivacyPage from './components/Pages/PrivacyPage';
import CookiesPage from './components/Pages/CookiesPage';
import './styles.css';

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');

  const navigate = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const renderPage = () => {
    switch(currentPage) {
      case 'services':
        return <ServicesPage />;
      case 'platforms':
        return <PlatformsPage />;
      case 'about':
        return (
          <>
            <AboutPage expanded={true} />
            <TeamSection />
          </>
        );
      case 'contact':
        return <ContactPage />;
      case 'terms':
        return <TermsPage />;
      case 'privacy':
        return <PrivacyPage />;
      case 'cookies':
        return <CookiesPage />;
      default:
        return <HomePage />;
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <LayoutHeader navigate={navigate} />
      <main className="flex-grow">
        {renderPage()}
      </main>
      <Footer navigate={navigate} />
      <CookieConsent />
    </div>
  );
};

export default App;